import * as m from "@/paraglide/messages"
import { cn } from "@/shared/lib/utils"
import { getLastSeenStatus, type LastSeenStatus } from "../lib/last-seen"
import type { Friend } from "../model/types"

const MESSAGE: Record<LastSeenStatus, () => string> = {
	today: m.lastSeenToday,
	yesterday: m.lastSeenYesterday,
	recently: m.lastSeenRecently,
	"long-ago": m.lastSeenLongAgo,
}

interface LastSeenProps {
	friend: Pick<Friend, "last_seen_at" | "is_online" | "is_invisible">
	className?: string
}

function getLabel(friend: LastSeenProps["friend"]): string | null {
	if (friend.is_online) return m.lastSeenOnline()

	const status = getLastSeenStatus(friend.last_seen_at)
	return status ? MESSAGE[status]() : null
}

export function LastSeen({ friend, className }: LastSeenProps) {
	if (friend.is_invisible) return null

	const label = getLabel(friend)
	if (!label) return null

	return (
		<p
			className={cn(
				"text-center text-[11px] leading-2.75 font-semibold whitespace-nowrap text-[#77809b]",
				className,
			)}
		>
			{label}
		</p>
	)
}
